import React, { useEffect, useState } from "react";

function App() {
  const [characters, setCharacters] = useState([]);
  const [perks, setPerks] = useState([]);
  const [role, setRole] = useState("survivor");
  const [selectedCharacter, setSelectedCharacter] = useState(null);
  const [characterPerks, setCharacterPerks] = useState([]);
  const [imageError, setImageError] = useState(false);
  const SUBFOLDER = window.location.pathname.startsWith("/dbd2") ? "/dbd2" : "";
  const BASE_URL = window.location.origin + SUBFOLDER;

  // 🧠 Hilfsfunktionen
  const getImagePath = (imagePathFromJson) => {
    return `${BASE_URL}/images/${imagePathFromJson}`;
  };

function getPerkImagePath(perkImagePath) {
  if (!perkImagePath || typeof perkImagePath !== "string") return null;

  // Match ab Icons/Perks/... mit Unterordner + Dateinamen
  const match = perkImagePath.match(/Icons\/Perks\/.+$/);
  if (!match) return null;

  return `${BASE_URL}/images/UI/${match[0]}.png`;
}

  // 🗂 Daten laden
  useEffect(() => {
    async function loadData() {
      const charRes = await fetch(`${BASE_URL}/data/characters.json`);
      const perkRes = await fetch(`${BASE_URL}/data/perks.json`);

      let chars = await charRes.json();
      let allPerks = await perkRes.json();

      if (!Array.isArray(chars)) chars = Object.values(chars);
      if (!Array.isArray(allPerks)) allPerks = Object.values(allPerks);

      setCharacters(chars);
      setPerks(allPerks);
    }

    loadData();
  }, []);

  // 🎲 Zufalls-Charakter + Perks
  const rollCharacter = () => {
    const filtered = characters.filter(
      (c) => (c.role || c.type)?.toLowerCase() === role
    );
    if (!filtered.length) return;

    const randomChar = filtered[Math.floor(Math.random() * filtered.length)];
    setSelectedCharacter(randomChar);
    setImageError(false);

    const rolePerks = perks.filter(
      (p) => (p.role || p.type)?.toLowerCase() === role
    );

    const selectedPerks = [];
    const used = new Set();

    while (selectedPerks.length < 4 && rolePerks.length > 0) {
      const randomPerk =
        rolePerks[Math.floor(Math.random() * rolePerks.length)];
      if (!used.has(randomPerk.name)) {
        selectedPerks.push(randomPerk);
        used.add(randomPerk.name);
      }
    }

    setCharacterPerks(selectedPerks);
  };

  return (
  
    <div className="p-4 text-white bg-gray-900 min-h-screen">
	
      <h1 className="text-2xl font-bold mb-4">Dead by Daylight Companion</h1>

      {/* Buttons */}
      <div className="flex gap-2 mb-4">
        <button
          onClick={() => {
            setRole("survivor");
            setSelectedCharacter(null);
            setCharacterPerks([]);
          }}
          className={`px-4 py-2 rounded ${
            role === "survivor"
              ? "bg-blue-600"
              : "bg-gray-700 hover:bg-gray-600"
          }`}
        >
          Survivor
        </button>
        <button
          onClick={() => {
            setRole("killer");
            setSelectedCharacter(null);
            setCharacterPerks([]);
          }}
          className={`px-4 py-2 rounded ${
            role === "killer" ? "bg-red-600" : "bg-gray-700 hover:bg-gray-600"
          }`}
        >
          Killer
        </button>
        <button
          onClick={rollCharacter}
          className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded"
        >
          Zufall!
        </button>
      </div>

      {/* Charakter Spalte */}
      {selectedCharacter && (
        <div className="bg-gray-800 p-4 rounded flex gap-6 items-start">
          {/* Bilder-Spalte */}
          <div className="bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 rounded-lg shadow-lg p-4 w-[300px] h-[600px]">
				<div className="text-lg font-bold mb-2 flex items-center justify-between text-white">
				  <h3>{selectedCharacter.name}</h3>
				</div>				  
            {!imageError && selectedCharacter.image && (
              <img
                src={getImagePath(selectedCharacter.image)}
                alt={selectedCharacter.name}
                className="w-36 h-36 object-cover rounded border border-gray-700"
                onError={() => {
                  console.warn("❌ Bild nicht gefunden:", getImagePath(selectedCharacter.image));
                  setImageError(true);
                }}
              />
            )}
				<div className="text-sm text-gray-300 mt-4 space-y-1">
				  <div>{selectedCharacter.bio}</div>
				</div>			 	
			
          </div>

          {/* Perk-Spalte */}
			<div className="grid grid-cols-4 gap-6 justify-center">
			  {characterPerks.map((perk) => (
				<div
				  key={perk.name}
				  className="bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 rounded-lg shadow-lg p-4 w-[300px] h-[600px]"
				>
				  {/* Titel mit Bild */}
				  <h4 className="text-lg font-bold mb-2 flex items-center justify-between text-white">
					{perk.name}
					<img
					  src={getPerkImagePath(perk.image)}
					  alt={perk.name}
					  className="w-16 h-16 object-contain border border-gray-600 rounded"
					  onError={(e) => (e.target.style.display = "none")}
					/>
				  </h4>


				  {/* Beschreibung */}
				  <p className="text-sm text-gray-300 mt-2 overflow-y-auto">
					{perk.description}
				  </p>
				</div>
			  ))}
			</div>
        </div>
      )}
    </div>
  );
}

export default App;